// Группированный по категориям список FAQ-статей.
// Используется в SupportModal и на странице /support.
import React, { useEffect, useState } from "react";
import { listFaq } from "../../api/tickets";

const CATEGORY_LABELS = {
  rublox_general: "Про Рублокс",
  rublox_studio: "Студия (создание игр)",
  account: "Аккаунт",
  mobile_app: "Мобильное и десктоп приложение",
};

/**
 * Props:
 *   onPickArticle(article) — клик по статье
 *   maxPerCategory — ограничить кол-во статей на категорию (для модалки)
 */
export default function FaqList({ onPickArticle, maxPerCategory }) {
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    let cancelled = false;
    listFaq()
      .then((d) => { if (!cancelled) setData(d); })
      .catch((e) => { if (!cancelled) setErr(e.message); });
    return () => { cancelled = true; };
  }, []);

  if (err) return <div className="sup-msg-err">Не удалось загрузить FAQ: {err}</div>;
  if (!data) return <div className="sup-msg-info">Загрузка…</div>;

  const cats = Object.keys(data);
  if (cats.length === 0) {
    return <div className="sup-msg-info">FAQ пока пуст.</div>;
  }

  return (
    <div>
      {cats.map((cat) => {
        let items = data[cat] || [];
        if (maxPerCategory) items = items.slice(0, maxPerCategory);
        if (items.length === 0) return null;
        return (
          <div key={cat} className="sup-faq-group">
            <div className="sup-faq-group__title">
              {CATEGORY_LABELS[cat] || cat}
            </div>
            {items.map((a) => (
              <button
                key={a.id}
                type="button"
                className="sup-faq-item"
                onClick={() => onPickArticle && onPickArticle(a)}
              >
                {a.pinned && (
                  <span className="sup-faq-item__pin" aria-label="закреплено">
                    <svg width="10" height="10" viewBox="0 0 24 24"
                         fill="currentColor" stroke="none">
                      <path d="M12 2l2.9 6.5 7.1.7-5.4 4.8 1.6 7L12 17.7 5.8 21l1.6-7L2 9.2l7.1-.7L12 2z" />
                    </svg>
                  </span>
                )}
                <span className="sup-faq-item__title">{a.title}</span>
              </button>
            ))}
          </div>
        );
      })}
    </div>
  );
}
